exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".mr-15[data-v-710656c6]{margin-right:-15px}", "", {"version":3,"sources":["/home/ubuntu/codebase2/frontendv2/src/components/common/cartWidgets.vue"],"names":[],"mappings":"AACA,wBACE,kBAAoB,CACrB","file":"cartWidgets.vue","sourcesContent":["\n.mr-15[data-v-710656c6] {\n  margin-right: -15px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"id":"data-v-710656c6","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/cartWidgets.vue
// module id = 1248
// module chunks = 0 14 17